// import logo from './logo.svg';
import './App.css';
import React from 'react';
import { Line } from 'react-chartjs-2';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
// import DoneIcon from '@material-ui/icons/Done';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import CircularProgress from '@material-ui/core/CircularProgress';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel'
import Input from '@material-ui/core/Input';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
// import IconButton from '@material-ui/core/IconButton';
// import MenuIcon from '@material-ui/icons/Menu';
const firebase = require("firebase");

firebase.initializeApp({
  apiKey: 'AIzaSyBDEHjO4ZRA7niLz7_Biww2ZiXpf5iHWyE',
  authDomain: 'ph-trendy.firebaseapp.com',
  projectId: 'ph-trendy'
});

var db = firebase.firestore();

// const useStyles = makeStyles(theme => ({
//   root: {
//     display: 'flex',
//     justifyContent: 'center',
//     flexWrap: 'wrap',
//   },
//   chip: {
//     margin: theme.spacing(1),
//   },
//   menuButton: {
//     marginRight: theme.spacing(2),
//   },
//   title: {
//     flexGrow: 1,
//   },
// }));

class App extends React.Component {
  // const inputLabel = React.useRef(null);
  constructor(props) {
    super(props);
    this.handleMetric = this.handleMetric.bind(this);
    this.handlePeriod = this.handlePeriod.bind(this);
    this.handleSelTopic = this.handleSelTopic.bind(this);
    this.handleNav = this.handleNav.bind(this);

    this.state = {
      topicList: [],
      loading: true,
      selectedTopics: {},
      metric: 'votes',
      stPeriod: '2019',
      openCSMsg: false
    };
  }

  componentDidMount() {
    let self = this;
    // Import Topics dataset
    db.collection("topics").orderBy('followersCount').get().then((querySnapshot) => {
      let selInits = {};
      for (var i = 0; i < querySnapshot.docs.length; i++) {
        selInits[querySnapshot.docs[i].id] = true;
        if (i === 9) {
          break;
        }
      }

      self.setState({
        topicList: querySnapshot.docs,
        loading: false,
        selectedTopics: selInits
      });
    });
  }

  render() {
    // const classes = useStyles();

    let labelList = ['January', 'February', 'March', 'April', 'May', 'June'];
    if (this.state.stPeriod === '2018') {
      labelList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    } else if (this.state.stPeriod === 'All') {
      labelList = ['Jan-18', 'Feb-18', 'Mar-18', 'Apr-18', 'May-18', 'Jun-18', 'Jul-18', 'Aug-18', 'Sep-18', 'Oct-18', 'Nov-18', 'Dec-18', 'Jan-19', 'Feb-19', 'Mar-19', 'Apr-19', 'May-19', 'Jun-19'];
    }

    const data = {
      labels: labelList,
      datasets: []
    };

    let colors = [
      '#00bcd4',
      '#cddc39',
      '#ffc107',
      '#ffeb3b',
      '#f06292',
      '#ffffff',
      '#ce93d8',
      '#81c784',
      '#00e676',
      '#03a9f4',
    ]

    let topicChips = [];
    for (var i = 0; i < this.state.topicList.length; i++) {
      let topData = this.state.topicList[i].data();

      // Funnel Settings
      let metricEP = this.state.metric === 'votes' ? topData.votes : topData.postCount;
      let metricSwitch = metricEP ? this.state.stPeriod === 'All' || Number(this.state.stPeriod) in metricEP ? true : false : false;

      if ((this.state.topicList[i].id in this.state.selectedTopics) && metricSwitch) {
        // let numMonths = Object.keys(metricEP[2019]).length - 1;
        let numYrs = this.state.stPeriod === 'All' ? 2 : 1;
        let numMonths = this.state.stPeriod === '2019' ? 6 : 12;

        let monthCounts = [];

        for (var k = 0; k < numYrs; k++) {
          let lookupYr = this.state.stPeriod === 'All' || this.state.stPeriod === '2018' ? 2018 : 2019;
          lookupYr += k;

          for (var j = 0; j < numMonths; j++) {
            let cumCount = j > 0 ? monthCounts[monthCounts.length - 1] : 0;

            if (metricEP[lookupYr] && j in metricEP[lookupYr]) {
              cumCount += metricEP[lookupYr][j].count;
            }

            monthCounts.push(cumCount);
          }
        }

        let dataColor = colors.length - 1 >= data.datasets.length ? colors[data.datasets.length] : '#c6ff00';

        data.datasets.push(
          {
            label: topData.name,
            fill: false,
            lineTension: 0.1,
            backgroundColor: dataColor,
            borderColor: dataColor,
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: dataColor,
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: dataColor,
            pointHoverBorderColor: 'rgba(220,220,220,1)',
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: monthCounts
          }
        )
      }

      topicChips.push(
        <Chip
          key={this.state.topicList[i].id}
          label={topData.name}
          clickable
          style={{margin: 15}}
          // className={classes.chip}
          color={this.state.topicList[i].id in this.state.selectedTopics ? 'secondary' : "primary"}
          onClick={this.handleSelTopic.bind(null, this.state.topicList[i].id)}
          // onDelete={handleDelete}
          // deleteIcon={<DoneIcon />}
        />
      );
    }

    let content;
    if (this.state.loading) {
      content = (
        <div style={{margin: '40px auto', width: '80%'}}>
          <Typography variant='h3' style={{marginBottom: 50}}>Analyzing Trends...</Typography>
          <CircularProgress style={{width: 250, height: 250}} />
        </div>
      );
    } else {
      content = (
        <div style={{margin: '40px auto', width: '80%'}}>
          <div style={{marginTop: 60, marginBottom: 40}}>
            {/* <Typography variant='h2' style={{marginBottom: 30}}>Top 10 Topics (2019)</Typography> */}
            {/* <Typography>Spot top trends in PH 😸</Typography> */}
          </div>
          <div style={{textAlign: 'center'}}>
            <Paper style={{width: '80%', margin: '40px auto', textAlign: 'center', padding: 15}}>
              <Typography variant='subtitle2' style={{marginBottom: 15}}>Settings</Typography>
              <div>
                <div style={{display: 'inline-block', verticalAlign: 'middle', margin: '0 20px'}}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">Metric</FormLabel>
                    <RadioGroup
                      aria-label="Metric"
                      name="metric"
                      value={this.state.metric}
                      onChange={this.handleMetric.bind(null)}
                    >
                      <FormControlLabel value="votes" control={<Radio />} label="Votes" />
                      <FormControlLabel value="posts" control={<Radio />} label="Posts" />
                    </RadioGroup>
                  </FormControl>
                </div>
                <div style={{display: 'inline-block', verticalAlign: 'middle', margin: '0 20px'}}>
                  <FormControl variant="outlined">
                    <InputLabel htmlFor="outlined-period-simple">
                      Period
                    </InputLabel>
                    <Select
                      value={this.state.stPeriod}
                      onChange={this.handlePeriod.bind(null)}
                      input={<OutlinedInput labelWidth={150} name="period" id="outlined-age-simple" />}
                    >
                      {/* <MenuItem value='All'>All</MenuItem> */}
                      <MenuItem value='2019'>2019</MenuItem>
                      <MenuItem value='2018'>2018</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
            </Paper>
          </div>
          <Line
            data={data}
            width={100}
            height={50}
            options={{
              // maintainAspectRatio: false,
              legend: {
                labels: {
                  fontColor: '#fff'
                }
              }
            }}
          />
          <div style={{textAlign: 'center'}}>
            <Typography variant='h6' style={{margin: '20 auto'}}>Click to add above!</Typography>
            {topicChips}
          </div>
        </div>
      );
    }

    return (
      <div className="App">
        <Dialog
          open={this.state.openCSMsg}
          onClose={this.handleNav}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Coming Soon..."}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              This feature is not ready yet! We're working on analyzing the top keywords & products for each topic, so stay tuned!
              <br/>
              <br/>
              Vote for us <a href="https://www.producthunt.com/makers-festival/product-hunt-api-2-0/" target='_blank'>here</a> and we'll let you know once it's ready.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleNav} color="primary" autoFocus>
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <header className="App-header">
          <AppBar position="absolute" style={{backgroundColor: '#2196F3', top: 0}}>
            <Toolbar>
              {/* <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="Menu">
                <MenuIcon />
              </IconButton> */}
              <Typography variant="h6" style={{marginRight: 15}}>
              {/* <Typography variant="h6" className={classes.title}> */}
                PH Trendy
              </Typography>
              <div style={{textAlign: 'left'}}>
                <Button color="inherit" style={{fontWeight: 500}}>Home</Button>
                <Button color="inherit" style={{fontWeight: 500}} onClick={this.handleNav.bind(null)}>Topics</Button>
              </div>
            </Toolbar>
          </AppBar>
          {/* <img src={logo} className="App-logo" alt="logo" /> */}
          {/* <Typography variant='h2' style={{margin: '50px auto'}}>PH Trendy</Typography> */}
          {content}
        </header>
      </div>
    );
  }

  handleMetric(e) {
    this.setState({ metric: e.target.value });
  }

  handlePeriod(e) {
    this.setState({ stPeriod: e.target.value });
  }

  handleSelTopic(topicID) {
    let newTopics = this.state.selectedTopics;

    if (topicID in newTopics) {
      delete newTopics[topicID];
    } else {
      newTopics[topicID] = true;
    }

    this.setState({ selectedTopics: newTopics });
  }

  handleNav() { this.setState({ openCSMsg: !this.state.openCSMsg }); }
}

export default App;
